import _extends from "@babel/runtime/helpers/esm/extends";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { ICON_SIZE_OPTIONS } from '../../utils/constants';
import { transformIconProps } from '../../utils/icons';
var IconUiSad = function IconUiSad(props) {
  return jsx("svg", _extends({
    width: "16",
    height: "16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, transformIconProps(props)), jsx("g", {
    stroke: "currentColor"
  }, jsx("path", {
    d: "M8 15.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M12.032 12a4.502 4.502 0 0 0-8.067 0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M5.5 6.25a.25.25 0 0 1 0-.5M5.5 6.25a.25.25 0 0 0 0-.5M10.5 6.25a.25.25 0 1 1 0-.5M10.5 6.25a.25.25 0 1 0 0-.5"
  })));
};
export { IconUiSad };